import { useEffect, useState } from 'react';
import { DidYouMean as DidYouMeanComponent } from '@coveo/headless';

interface IDidYouMeanProps {
  didYouMean: React.MutableRefObject<DidYouMeanComponent>;
}
export function DidYouMean({ didYouMean }: IDidYouMeanProps) {
  const [didYouMeanState, setDidYouMeanState] = useState(didYouMean.current.state);
  useEffect(() => {
    const unsub = didYouMean.current.subscribe(() => setDidYouMeanState(didYouMean.current.state));
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!didYouMeanState || !didYouMeanState.hasQueryCorrection) {
    return <></>;
  }
  if (didYouMeanState.wasAutomaticallyCorrected) {
    return (
      <div>
        <p>
          No results for <b>{didYouMeanState.queryCorrection.wordCorrections?.[0]?.originalWord}</b>
        </p>
        <p>
          Query was automatically corrected to <b>{didYouMeanState.wasCorrectedTo}</b>
        </p>
      </div>
    );
  }
  return (
    <button onClick={() => didYouMean.current.applyCorrection()}>
      Did you mean: {didYouMeanState.queryCorrection.correctedQuery} ?
    </button>
  );
}
